const KyberCurrenciesROP = {
  ETH: {
    symbol: 'ETH',
    name: 'Ethereum',
    contractAddress: '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee',
    decimals: 18
  },
  KNC: {
    symbol: 'KNC',
    name: 'Kyber Network',
    contractAddress: '0x4E470dc7321E84CA96FcAEDD0C8aBCebbAEB68C6',
    decimals: 18
  },
  OMG: {
    symbol: 'OMG',
    name: 'OmiseGO',
    contractAddress: '0x4BFBa4a8F28755Cb2061c413459EE562c6B9c51b',
    decimals: 18
  },
  SNT: {
    symbol: 'SNT',
    name: 'Status Network',
    contractAddress: '0xbF5d8683b9BE6C43fcA607eb2a6f2626A18837a6',
    decimals: 18
  },
  ELF: {
    symbol: 'ELF',
    name: 'AELF',
    contractAddress: '0x9Fcc27c7320703c43368cf1A4bf076402cd0D6B4',
    decimals: 18
  },
  POWR: {
    symbol: 'POWR',
    name: 'Power Ledger',
    contractAddress: '0xa577731515303F0C0D00E236041855A5C4F114dC',
    decimals: 6
  },
  MANA: {
    symbol: 'MANA',
    name: 'Decentraland',
    contractAddress: '0xf5E314c435B3B2EE7c14eA96fCB3307C3a3Ef608',
    decimals: 18
  },
  BAT: {
    symbol: 'BAT',
    name: 'Basic Attention Token',
    contractAddress: '0xDb0040451F373949A4Be60dcd7b6B8D6E42658B6',
    decimals: 18
  },
  REQ: {
    symbol: 'REQ',
    name: 'Request',
    contractAddress: '0xb43D10BbE7222519Da899B72bF2c7f094b6F79D7',
    decimals: 18
  },
  GTO: {
    symbol: 'GTO',
    name: 'GIFTO',
    contractAddress: '0xe55c607d58c53b2B06A8E38f67F4c0FcAeEd2c31',
    decimals: 5
  },
  RDN: {
    symbol: 'RDN',
    name: 'Raiden',
    contractAddress: '0x5422Ef695ED0B1213e2B953CFA877029637D9D26',
    decimals: 18
  },
  APPC: {
    symbol: 'APPC',
    name: 'AppCoins',
    contractAddress: '0x2799f05B55d56be756Ca01Af40Bf7350787F48d4',
    decimals: 18
  },
  ENG: {
    symbol: 'ENG',
    name: 'Enigma',
    contractAddress: '0x95cc8d8f29D0f7fcC425E8708893E759d1599c97',
    decimals: 8
  },
  SALT: {
    symbol: 'SALT',
    name: 'Salt',
    contractAddress: '0xB47f1A9B121BA114d5e98722a8948e274d0F4042',
    decimals: 8
  },
  BQX: {
    symbol: 'BQX',
    name: 'Ethos',
    contractAddress: '0x9504A86A881F63Da06302FB3639d4582022097DB',
    decimals: 8
  },
  ADX: {
    symbol: 'ADX',
    name: 'AdEx',
    contractAddress: '0x499990DB50b34687CDaFb2C8DaBaE4E99d6F38A7',
    decimals: 4
  },
  AST: {
    symbol: 'AST',
    name: 'AirSwap',
    contractAddress: '0xeF06F410C26a0fF87b3a43927459Cce99268a2eF',
    decimals: 4
  },
  RCN: {
    symbol: 'RCN',
    name: 'Ripio Credit Network',
    contractAddress: '0x99338aa9218C6C23AA9d8cc2f3EFaf29954ea26B',
    decimals: 18
  },
  ZIL: {
    symbol: 'ZIL',
    name: 'Zilliqa',
    contractAddress: '0xaD78AFbbE48bA7B670fbC54c65708cbc17450167',
    decimals: 12
  },
  DAI: {
    symbol: 'DAI',
    name: 'DAI',
    contractAddress: '0xaD6D458402F60fD3Bd25163575031ACDce07538D',
    decimals: 18
  },
  LINK: {
    symbol: 'LINK',
    name: 'Chain Link',
    contractAddress: '0xb4f7332ed719Eb4839f091EDDB2A3bA309739521',
    decimals: 18
  },
  IOST: {
    symbol: 'IOST',
    name: 'IOStoken',
    contractAddress: '0x27db28a6C4ac3D82a08D490cfb746E6F02bC467C',
    decimals: 18
  },
  STORM: {
    symbol: 'STORM',
    name: 'Storm',
    contractAddress: '0x8FFf7De21de8ad9c510704407337542073FDC44b',
    decimals: 18
  },
  BBO: {
    symbol: 'BBO',
    name: 'BigBom',
    contractAddress: '0xa94758d328af7ef1815e73053e95b5F86588C16D',
    decimals: 18
  },
  COFI: {
    symbol: 'COFI',
    name: 'ConFi',
    contractAddress: '0xb91786188f8d4e35d6d67799e9f162587bf4da03',
    decimals: 18
  },
  MOC: {
    symbol: 'MOC',
    name: 'Moss Coin',
    contractAddress: '0x1742c81075031b8f173d2327e3479d1fc3feaa76',
    decimals: 18
  },
  BITX: {
    symbol: 'BITX',
    name: 'BitScreenerToken',
    contractAddress: '0x7a17267576318efb728bc4a0833e489a46ba138f',
    decimals: 18
  }
};

export { KyberCurrenciesROP };
